import { render, staticRenderFns } from "./VeJwJingsaiProjectModal.vue?vue&type=template&id=17ded8a4"
import script from "./VeJwJingsaiProjectModal.vue?vue&type=script&lang=js"
export * from "./VeJwJingsaiProjectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports